import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Badge } from '@mentimeter/ragnar-ui/badge';
import type { FlagVariantT } from '../../types';
import { Heading } from './Heading';

export function FlagSection({
  children,
  id,
  title,
  variant = 'none',
}: {
  children: React.ReactNode;
  id: string;
  title: string;
  variant?: FlagVariantT | 'none';
}) {
  return (
    <Box width="100%" data-testid={`flag-section-${id}`}>
      <Heading>
        <Box mb="space2" flexDirection="row" alignItems="center">
          <Text color="text" fontWeight="semiBold">
            {title}
          </Text>
          {variant === 'development' && (
            <Badge
              ml="space1"
              compact
              type="text"
              color="onNoticeWeak"
              bg="noticeWeak"
              text="Development"
            />
          )}
          {variant === 'confidence' && (
            <Badge
              ml="space1"
              compact
              type="text"
              color="onPositiveWeak"
              bg="positiveWeak"
              text="Confidence"
            />
          )}
        </Box>
      </Heading>
      {children}
    </Box>
  );
}

export function FlagList({ children }: { children: React.ReactNode }) {
  return <Box width="100%">{children}</Box>;
}
